export class SaveManager {
  constructor() {
    this.storageKey = 'poes_quest_save'
  }
  
  save(data, slot = 0) {
    try {
      const saves = this.getAllSaves()
      saves[slot] = {
        data,
        timestamp: Date.now(),
        date: new Date().toLocaleString()
      }
      localStorage.setItem(this.storageKey, JSON.stringify(saves))
      return true
    } catch (e) {
      console.error('Failed to save game:', e)
      return false
    }
  }
  
  load(slot = 0) {
    try {
      const saves = this.getAllSaves()
      if (saves[slot]) {
        return saves[slot].data
      }
      return null
    } catch (e) {
      console.error('Failed to load game:', e)
      return null
    }
  }
  
  getAllSaves() {
    try {
      const data = localStorage.getItem(this.storageKey)
      return data ? JSON.parse(data) : {}
    } catch (e) {
      return {}
    }
  }
  
  deleteSave(slot = 0) {
    try {
      const saves = this.getAllSaves()
      delete saves[slot]
      localStorage.setItem(this.storageKey, JSON.stringify(saves))
      return true
    } catch (e) {
      return false
    }
  }
  
  hasSave(slot = 0) {
    const saves = this.getAllSaves()
    return saves[slot] !== undefined
  }
}
